import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { toast } from "react-toastify";
import {
  useVerifyDirectEmailOtpMutation,
  useVerifyForNumberMutation,
} from "../../../redux/services/api";
import OTPVerification from "./VerifyOTP";
import AddEmail from "./AddEmail";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onAllow: () => void;
  alreadySavedEmail: string | null;
};

const UserProfileGate = ({
  isOpen,
  onClose,
  onAllow,
  alreadySavedEmail,
}: Props) => {
  const [verifyForNumber] = useVerifyForNumberMutation();
  const [verifyDirectEmailOtp] = useVerifyDirectEmailOtpMutation();
  const [loading, setLoading] = useState(false);
  const [screen, setScreen] = useState<"add-email" | "verify-otp" | null>(null);
  const [email, setEmail] = useState<string>("");

  const handleSendOtp = async (email: string) => {
    setLoading(true);
    try {
      const res = await verifyForNumber({
        email,
      }).unwrap();
      debugger;
      setEmail(email);
      setScreen("verify-otp");

    } catch (error: any) {
      toast.error(error?.data?.message || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (code: string) => {
    setLoading(true);
    try {
      const res = await verifyDirectEmailOtp({
        otp: code,
      }).unwrap();
      debugger;
      onAllow();

      // toast.success(res.message);
    } catch (error: any) {
      toast.error(error?.data?.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (alreadySavedEmail) {
      handleSendOtp(alreadySavedEmail)
    } else {
      setScreen("add-email");
    }
  }, [alreadySavedEmail]);

  return (
    <Modal open={isOpen} footer={null} onCancel={onClose} centered>
      {screen === "add-email" ? (
        <AddEmail handleSend={handleSendOtp} />
      ) : (
        <OTPVerification
          handleVerify={handleVerifyOtp}
          loading={loading}
          email={alreadySavedEmail || email}
        />
      )}
    </Modal>
  );
};

export default UserProfileGate;
